import { useEffect, useState } from "react";
import { getUrlSearchParams } from "../../urlParams";
import { ApiEndpoints, reqPatch, reqPostNew } from "../../../config/apiClient";
import LoadingModal from "../../../components/loadingModal";
import { Button, Col } from "react-bootstrap";
import { MostrarCaminhoAtual } from "../all/NavegacaoDocumentos";
import dayjs from "dayjs";
import { DocumentoStatus } from "../pendentes/PainelDocumentosPendentes";
import css from "./styles.module.css";
import { toast } from "react-toastify";
import ModalDocumentoRenomear from "./ModalDocumentoRenomear";
import ModalDocumentoMoverParaPasta from "./ModalDocumentoMoverParaPasta";
import { getCookie } from "../../../config/cookies";

export default function DocumentoViewPage() {
    const [loading, setLoading] = useState<boolean>(false);
    const [showModalRenomear, setShowModalRenomear] = useState<boolean>(false);
    const [showModalPasta, setShowModalPasta] = useState<boolean>(false);
    const [permissaoEditar, setPermissaoEditar] = useState<boolean>(false);
    const [documentoDados, setDocumentoDados] = useState<any>({});
    useEffect(() => {
        document.title = "Documento | OB PORTUS APP";
        const urlDados = getUrlSearchParams();
        const codigo = urlDados.get("id");
        getDocumentoDados(codigo);
        // eslint-disable-next-line
    }, []);

    async function getDocumentoDados(codigo: string | null) {
        const dados = {
            codigo: codigo,
        };
        setLoading(true);
        const api = await reqPostNew(ApiEndpoints.documentoDados, dados);
        if (api.status === 200) {
            const documento = api.data;
            setDocumentoDados(documento);
            document.title = `DOC ${documento.nome} | OB PORTUS APP`;
            const id_usuario = Number(getCookie("id_user"));
            const id_usuario_resp = documento.id_usuario.id;
            if (id_usuario === id_usuario_resp || id_usuario === 1) {
                setPermissaoEditar(true);
            }
        }
        setLoading(false);
    }

    async function handleRenomear(dados: any) {
        setShowModalRenomear(false);
        setLoading(true);
        const api = await reqPatch(ApiEndpoints.documentoRenomear, dados);
        if (api.status === 200) {
            toast.success(`Nome editado com sucesso!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
        await getDocumentoDados(dados.codigo);
        setLoading(false);
    }

    async function handleDeletar() {
        if (!window.confirm("Tem certeza que deseja excluir o documento?")) {
            return;
        }

        const dados = {
            id_documento: documentoDados.id,
            id_usuario: Number(getCookie("id_user")),
        };
        setLoading(true);
        const api = await reqPostNew(ApiEndpoints.documentoDeletar, dados);
        if (api.status === 200) {
            toast.success(`Documento deletado!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            let id_pasta = 0;
            if (documentoDados.id_pasta !== null) {
                id_pasta = documentoDados.id_pasta.id_pasta;
            }
            window.location.href = `/documentos/todos?pasta=${id_pasta}`;
        } else {
            setLoading(false);
        }
    }

    async function handlePastaMover(id_pasta: number) {
        setShowModalPasta(false);
        setLoading(true);
        const dados = {
            codigos: [documentoDados.codigo],
            id_pasta: id_pasta,
        };
        const api = await reqPatch(ApiEndpoints.documentoMoverPasta, dados);
        if (api.status === 200) {
            toast.success(`Documento movido com sucesso!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await getDocumentoDados(documentoDados.codigo);
        }
        setLoading(false);
    }

    function handleCriarDocumento(mouseClick: number) {
        let id_pasta = null;
        if (documentoDados.id_pasta !== null) {
            id_pasta = documentoDados.id_pasta.id_pasta;
        }
        let link_criar_documento = `${ApiEndpoints.baseSite}/documento/novo?pasta=${id_pasta}`;
        // let link_criar_documento = `${ApiEndpoints.apiOld}/dashboard/documentos/criar?pasta=${id_pasta}`
        if (id_pasta === null || id_pasta === 0) {
            link_criar_documento = `${ApiEndpoints.baseSite}/documento/novo`;
            // link_criar_documento = `${ApiEndpoints.apiOld}/dashboard/documentos/criar`
        }
        if (mouseClick === 1) {
            window.open(link_criar_documento);
            return;
        }
        if (mouseClick === 0) {
            window.location.href = link_criar_documento;
            return;
        }
    }

    if (Object.values(documentoDados).length === 0) {
        return (
            <div id="main">
                <LoadingModal handleClose={() => {}} show={loading} />
                <p>Carregando Documento ...</p>
            </div>
        );
    }
    return (
        <div id="main">
            <LoadingModal handleClose={() => {}} show={loading} />
            <ModalDocumentoRenomear
                show={showModalRenomear}
                documento={documentoDados}
                handleClose={() => {
                    setShowModalRenomear(false);
                }}
                handleRenomear={handleRenomear}
            />
            {showModalPasta && (
                <ModalDocumentoMoverParaPasta
                    show={showModalPasta}
                    handleClose={() => {
                        setShowModalPasta(false);
                    }}
                    handlePasta={handlePastaMover}
                />
            )}

            <h1 id="titleMain">Documento{Object.values(documentoDados).length > 0 && <span>: {documentoDados.nome}</span>}</h1>
            <br></br>

            <div className="div-row" style={{ backgroundColor: "lightgrey", padding: "10px", borderRadius: "10px", width: "fit-content" }}>
                <MostrarCaminhoAtual pastas={documentoDados.caminho} />
                {permissaoEditar && (
                    <div className="div-row">
                        <Button
                            onClick={() => {
                                window.location.assign(`/documento/novo?codigo=${documentoDados.codigo}`);
                            }}
                            style={{ marginRight: "10px" }}
                            size="sm"
                        >
                            Editar Definições
                        </Button>
                        <Button
                            onClick={() => {
                                setShowModalRenomear(true);
                            }}
                            style={{ marginRight: "10px" }}
                            size="sm"
                        >
                            Renomear
                        </Button>
                        <Button
                            onClick={() => {
                                setShowModalPasta(true);
                            }}
                            style={{ marginRight: "10px" }}
                            size="sm"
                        >
                            Mover para pasta
                        </Button>
                        <Button
                            onClick={() => {
                                handleDeletar();
                            }}
                            variant="danger"
                            size="sm"
                        >
                            Deletar
                        </Button>
                    </div>
                )}
                <Button
                    onClick={(event) => {
                        handleCriarDocumento(event.button);
                    }}
                    onMouseUp={(event) => {
                        handleCriarDocumento(event.button);
                    }}
                    onMouseDown={(event) => {
                        if (event.button === 1) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }}
                    style={{ marginLeft: "10px" }}
                    size="sm"
                >
                    Novo Documento
                </Button>
            </div>

            <br></br>

            <div className="div-row" style={{ alignItems: "start" }}>
                <Col className="col-12">
                    <p>
                        #{documentoDados.id} Criado em {dayjs(documentoDados.data_criacao).format("DD/MM/YYYY HH:mm")}
                    </p>
                    <p>Por {documentoDados.id_usuario === null ? "Não informado" : documentoDados.id_usuario.nome}</p>
                    {String(documentoDados.original_caminho).search("local") > 0 && <p className={css.documento_local_aviso}>HOMOLOGAÇÃO DEV</p>}
                    <br></br>
                    <DocumentoStatus id_status={documentoDados.id_status.id_status} status={documentoDados.id_status.descricao} lixeira={documentoDados.lixeira} />
                    {documentoDados.lixeira === 1 && (
                        <div>
                            <p style={{ marginTop: "5px" }}>Excluído em {dayjs(documentoDados.data_excluido).format("DD/MM/YYYY HH:mm")}</p>
                            {documentoDados.id_usuario_excluido !== null && <p>Por {documentoDados.id_usuario_excluido.nome}</p>}
                        </div>
                    )}
                    <br></br>

                    <p className={css.lista_signatarios}>Lista de Assinaturas</p>
                    <p>
                        {getQtdSignatarios(documentoDados.signatarios, "pendente")}/{getQtdSignatarios(documentoDados.signatarios, "total")} Concluído
                    </p>
                    <br></br>
                    <ListarSignatarios signatarios={documentoDados.signatarios} />
                </Col>
            </div>

            <p className={css.lista_signatarios}>Visualizar Documento</p>
            <br></br>
            <div className="div-row">
                <Button
                    onClick={() => {
                        window.open(`${ApiEndpoints.documentoVerOriginal.endpoint}${documentoDados.codigo}`, "_blank");
                    }}
                    variant="primary"
                    className="div-row"
                    style={{ marginRight: "10px" }}
                >
                    <p style={{ fontWeight: "bold", marginRight: "10px" }}>ARQUIVO ORIGINAL</p>
                    <span className="material-symbols-outlined" style={{ fontSize: "18px", padding: "0px" }}>
                        open_in_new
                    </span>
                </Button>

                {documentoDados.data_assinado !== null && (
                    <Button
                        onClick={() => {
                            window.open(`${ApiEndpoints.documentoVerAssinado.endpoint}${documentoDados.codigo}`, "_blank");
                        }}
                        variant="primary"
                        className="div-row"
                    >
                        <p style={{ fontWeight: "bold", marginRight: "10px" }}>ARQUIVO ASSINADO</p>
                        <span className="material-symbols-outlined" style={{ fontSize: "18px", padding: "0px" }}>
                            open_in_new
                        </span>
                    </Button>
                )}
            </div>
        </div>
    );

    function getQtdSignatarios(dados: any[], tipo: "pendente" | "total"): number {
        if (tipo === "total") {
            return dados.length;
        }

        let qtd = 0;
        for (let signatario of dados) {
            if (signatario.data_assinado !== null || signatario.data_recusado !== null) {
                qtd++;
            }
        }
        return qtd;
    }
}

function ListarSignatarios({ signatarios }: iPropsSignatarios) {
    if (signatarios.length === 0) {
        return (
            <div className={css.div_signatario}>
                <p>Não foi informado signatários.</p>
            </div>
        );
    }

    return (
        <div>
            {signatarios.map((sig, idx, array) => {
                let color = "#6c757d";
                let status = "Documento não foi visualizado.";
                if (sig.data_ultima_visualizacao != null) {
                    color = "#f0a202";
                    status = `Visualizou ${sig.qtd_visualizacao} vezes o documento. Última visualização em ${dayjs(sig.data_ultima_visualizacao).format("DD/MM/YYYY HH:mm:ss")}.`;
                }
                if (sig.data_assinado != null) {
                    color = "#40bf4b";
                    status = `Documento assinado ${dayjs(sig.data_assinado).format("DD/MM/YYYY HH:mm:ss")}.`;
                }
                if (sig.data_recusado != null) {
                    color = "#b80220";
                    status = `Documento recusado ${dayjs(sig.data_recusado).format("DD/MM/YYYY HH:mm:ss")}.`;
                }
                return (
                    <div key={idx} className={css.div_signatario}>
                        <p style={{ fontWeight: "bold" }}>{sig.nome_completo}</p>
                        <p className={css.documento_link_assinar}>{sig.link_assinar}</p>
                        <p className={css.documento_status} style={{ color: color }}>
                            {status}
                        </p>
                        {sig.data_assinado === null && (
                            <div>
                                <Button
                                    size="sm"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        navigator.clipboard.writeText(sig.link_assinar).then(
                                            function () {
                                                toast.success("Copiado com sucesso!", {
                                                    containerId: 1,
                                                    position: "top-center",
                                                    theme: "dark",
                                                    autoClose: 750,
                                                });
                                            },
                                            function (err) {
                                                toast.success("Erro ao copiar!", {
                                                    containerId: 1,
                                                    position: "top-center",
                                                    theme: "dark",
                                                    autoClose: 750,
                                                });
                                                console.error("Async: Could not copy text: ", err);
                                            },
                                        );
                                    }}
                                    style={{ marginRight: "10px" }}
                                >
                                    Copiar Link
                                </Button>
                                <Button size="sm" variant="outline-success" onClick={() => {}}>
                                    Enviar Whatsapp
                                </Button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
interface iPropsSignatarios {
    signatarios: any[];
}
